import React from 'react';
const Tutors = () => <div className="service-page"><h1>Tutors</h1><p>Expert tutors for academic and professional subjects.</p></div>;
export default Tutors;
